/* eslint import/newline-after-import: "off" */
import {Component} from 'san';
// import login from '@baidu/xbox-interact-base/utils/login';
import topbarLogo from '../../assets/img/logo_top.png';
import styles from './style/index.module.less';

export default class Topbar extends Component {
    static template = require('./index.html');

    initData() {
        return {
            styles,
            topbarLogo,
            showMenu: false,
            showFlag: false,
            sendShowLog: false,
            loginUrl: '',
            logoutUrl: '',
        };
    }
    attached() {
        let loginUrl = 'https://passport.baidu.com/v2/?login&tpl=mn&u=' + encodeURIComponent(location.href);
        let logoutUrl = 'https://passport.baidu.com/?logout&u=' + encodeURIComponent(location.href);
        this.data.set('loginUrl', loginUrl);
        this.data.set('logoutUrl', logoutUrl);
    }
    onMouseEnter() {
        this.data.set('showFlag', true);
        this.data.set('showMenu', true);
        if (!this.data.get('sendShowLog')) {
            this.data.set('sendShowLog', true);
            this.storeDispatch('topBar:usrMenuShowLog');
        }
    }
    onMouseLeave() {
        this.data.set('showFlag', false);
        setTimeout(() => {
            if (!this.data.get('showFlag')) {
                this.data.set('showMenu', false);
            }
        }, 200);
    }
    logoClkHandler() {
        this.storeDispatch('topBar:logoClkLog');
    }
    menuClkHandler(event, type) {
        this.storeDispatch('topBar:menuClkLog', {type});
        // if (type === 'login') {
        //     event.preventDefault();
        //     event.stopPropagation();
        //     login({
        //         apiOpt: {
        //             staticPage: 'https://mbd.baidu.com/newspage/data/passlogin'
        //         },
        //         successCb: args => {
        //             this.storeDispatch('news:updateLogin');
        //         }
        //     }, false);
        // }
    }
    usrMenuClkHandler(event, pos, type) {
        this.storeDispatch('topBar:usrMenuClkLog', {pos, type});
    }
};
